import {useSelector} from "react-redux";
import {IApplicationState} from "../../store/Store";
import {UserDto} from "../apis/user/UserDto";

export function useCurrentUser(): UserDto {
    return useSelector((application: IApplicationState) => application.user.userData as UserDto);
}